const pharmaciesCountPlaceholders = document.querySelectorAll('.pharmacy-count');

if (pharmaciesCountPlaceholders.length > 0) {
    setPharmaciesCount();
}

async function setPharmaciesCount() {
    const response = await fetch('/Pharmacy/GetAllPharmaciesCount');
    const result = await response.json();

    if (result.data !== -1) {
        pharmaciesCountPlaceholders.forEach(element => {
            element.innerHTML = result.data;
        })
    }
}

